package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.RadioButton
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge
import top.wcpe.allincore.ui.runtime.theme.StateLayerCompositor
import top.wcpe.allincore.ui.runtime.theme.ThemeAccess
import kotlin.math.min

/**
 * 单选按钮渲染器（接入主题）。视觉规范与 Checkbox 一致；dot 用 `primary`。
 */
@Suppress("MagicNumber")
class RadioButtonRenderer : Renderer {

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge) {
        val rb = element as RadioButton
        val t = ThemeAccess.current()

        val focusBorder = rb.focusBorderColor() ?: t.primary
        // 未聚焦边框：逐实例 boxBorderColor 覆盖优先，否则回退主题 outline。
        val unfocusedBorder = rb.boxBorderColor() ?: t.outline
        val border = if (rb.focused()) focusBorder else unfocusedBorder
        // 外框背景：逐实例 boxBackgroundColor 覆盖优先，否则回退主题 surface。
        val boxBg = rb.boxBackgroundColor() ?: t.surface

        ControlSurfaceRenderer.drawSurface(bridge, rb, box, boxBg, border, t.borderWidth)

        if (rb.selected()) {
            val baseInset = rb.dotInset() ?: 4f
            val pad = min(baseInset, min(box.width(), box.height()) / 4f)
            val dot = rb.dotColor() ?: t.primary
            bridge.fillRect(
                box.x() + pad,
                box.y() + pad,
                box.width() - 2f * pad,
                box.height() - 2f * pad,
                dot,
            )
        }

        val overrides = StateLayerCompositor.overrides(
            rb.hoverOverlayColor(),
            rb.hoverOverlayOpacity(),
            rb.focusOverlayColor(),
            rb.focusOverlayOpacity(),
            rb.pressedOverlayColor(),
            rb.pressedOverlayOpacity(),
        )
        StateLayerCompositor.overlay(bridge, rb, box, t, false, overrides, false)
    }
}
